/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import EditReviewModal from '../components/EditReviewModal';
import ReviewListState from '../states/ReviewListState';
import reviewExportState from '../utils/reviewExportState';
import type User from 'flarum/common/models/User';
import { utils } from '@glowingblue-orell-thalia-common';
const { Auth } = utils;

export default function () {
	extend(DiscussionControls, 'moderationControls', function (items, discussion) {
		if (discussion.isReview() && discussion.canEditReview()) {
			items.add(
				'review',
				<Button icon="far fa-heart" onclick={() => app.modal.show(EditReviewModal, { discussion })}>
					{app.translator.trans('glowingblue-orell-rezensionen.forum.discussion_controls.edit_review_button')}
				</Button>
			);
		}
	});

	extend(DiscussionControls, 'userControls', function (items, discussion) {
		if (!discussion.user()) return;

		// `user()` is typed `User | false | null`; the guard above already ruled the falsy cases out.
		if (discussion.isReview() && app.session.user && app.session.user.id() === (discussion.user() as User).id()) {
			const { exported, blocked } = reviewExportState(discussion);

			items.add(
				'export',
				<Button
					icon="fa-kit fa-regular-cloud-circle-arrow-up"
					disabled={exported || blocked}
					onclick={async () => {
						// Borrowed for its export logic, one review at a time.
						const state = new ReviewListState({});

						if (!app.session.user!.attribute('linkedShop')) {
							try {
								await Auth.linkAccount(
									app.translator.trans('glowingblue-orell-rezensionen.forum.user.reviews.export_connect'),
									ReviewListState.gaExportAttrs
								);
							} catch (e) {
								console.log('Linking account failed.');
								console.log(e);
								return;
							}
						}

						discussion.pushAttributes({ selectedForExport: true });

						try {
							await state.exportOnly(discussion);
						} catch (e) {
							console.log('Exporting review failed.');
							console.log(e);
						}

						discussion.pushAttributes({ selectedForExport: false });
						m.redraw();
					}}
				>
					{app.translator.trans('glowingblue-orell-rezensionen.forum.discussion_controls.export_review_button')}
				</Button>
			);
		}
	});
}
